import { ReportNamingConvention } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/naming-convention.enum';
import { MODEL_PORTFOLIO } from 'NewAngular/constants/core.constants';
// Simple service to determine the name of a security based on the naming convention strategy. This is a dupe
// of the logic in our backend, but the logic is simple enough that it doesn't make sense create an endpoint just
// to service this function
export class NamingConventionService {
    static reportLabel(security, namingConvention, securityIDX) {
        if (security.securityId == null ||
            security.securityName == null ||
            security.displaySecurityID == null ||
            security.securityType == null)
            return '';
        switch (namingConvention) {
            case ReportNamingConvention.TRUNCATED:
                return security.securityName;
            case ReportNamingConvention.TICKER:
                return security.displaySecurityID;
            case ReportNamingConvention.LETTERING:
                const label = security.securityType === MODEL_PORTFOLIO ? 'Portfolio' : 'Security';
                return `${label} ${String.fromCharCode(securityIDX + 65)}`;
            case ReportNamingConvention.CUSTOM:
                return security.customLabel || '';
            default:
                throw new Error('Unrecognized naming convention');
        }
    }
}
